import React from "react";
import "../../pages/PlanningMap/index.css";
import { Col, Row, FormGroup, CustomInput } from "reactstrap";
import Constant from "constants/index";
import { Icon } from "shared";

type MenuToggleProps = {
  toggleMapToolbar: () => void;
  selectMapStyle: (mapStyle: any) => void;
  isEnableSelection: boolean;
  setEnableSelection: (isEnable: boolean) => void;
};

const MenuToggle = ({
  toggleMapToolbar,
  selectMapStyle,
  isEnableSelection,
  setEnableSelection,
}: MenuToggleProps) => {
  return (
    <div className="site-planning__map-toolbar-full">
      <div className="site-planning__map-toolbar-close-wrapper">
        <Icon name="close" fill size="small" onClick={toggleMapToolbar} />
      </div>
      <div className="site-planning__map-toolbar_section">
        <p className="site-planning__map-toolbar_section-title">
          Chế độ bản đồ
        </p>
        <Row>
          {Constant.MAP_STYLES.map((mapStyle) => (
            <Col key={mapStyle.styleCode} xs={6} sm={3} lg={2}>
              <img
                className="site-planning__map-toolbar_map-style-item"
                src={mapStyle.styleImg}
                onClick={() => selectMapStyle(mapStyle)}
                alt={mapStyle.title}
              />
            </Col>
          ))}
        </Row>
      </div>
      <div className="site-planning__map-toolbar_section">
        <p className="site-planning__map-toolbar_section-title">Lên kế hoạch</p>
        <FormGroup>
          <CustomInput
            className="site-planning__map-toolbar_section-switch"
            id="toogleEditSelectionCustomInput"
            type="switch"
            label="Bật chế độ chọn zone"
            onChange={(e) => setEnableSelection(e.target.checked)}
            checked={isEnableSelection}
          />
        </FormGroup>
      </div>
    </div>
  );
};

export default MenuToggle;
